/** Actions an admin can place on a Support insight spot. */
export const SupportInsightActionId = [
  "email-channel",
  "widget-ai",
  "widget-enabled",
  "social-ai",
] as const;
/** The retired id can still occur in previously saved insight slots. */
export const PersistedSupportInsightActionId = [
  ...SupportInsightActionId,
  "ai-ticket-volume",
] as const;
export type PersistedSupportInsightActionId =
  (typeof PersistedSupportInsightActionId)[number];
export type SupportInsightActionId = PersistedSupportInsightActionId;

/** Metric cards on the merchant Support dashboard, in page order. */
export const SupportInsightMetricLocationId = [
  "ticket-automation-rate",
  "total-tickets-automated",
  "potential-cost-savings",
  "total-tickets",
  "created-tickets",
  "closed-tickets",
  "resolved-tickets",
  "median-first-response-time",
  "median-first-human-response",
  "median-time-to-resolution",
] as const;
export type SupportInsightMetricLocationId =
  (typeof SupportInsightMetricLocationId)[number];

export const teamsPageBannerLocationId = "teams-page-banner";

/** Metric cards plus the fixed Teams page banner. */
export const SupportInsightSlotLocationId = [
  ...SupportInsightMetricLocationId,
  teamsPageBannerLocationId,
] as const;
export type SupportInsightSlotLocationId =
  (typeof SupportInsightSlotLocationId)[number];

/** Three metric-card spots, then the Teams page banner. */
export const SUPPORT_INSIGHT_SLOT_COUNT = 4;
export const SUPPORT_INSIGHT_METRIC_SLOT_COUNT = 3;

/**
 * One saved Support insight. `action` is absent when the spot is empty.
 * The last slot's location is always the Teams page banner.
 */
export interface SupportInsightSlot {
  action?: SupportInsightActionId | null;
  location: SupportInsightSlotLocationId;
  /** Whether this spot is shown. Absent means on. */
  enabled?: boolean;
}
